import React from 'react'
import TabViewAmenities from './page-components/Amenities/TabViewAmenities'
import TabAddPkgAmenites from './page-components/pkg-amenities/TabAddPkgAmenites'
import MasterPageTab from './page-essential/MasterPageTab'
import SideNav from './page-essential/SideNav'

const AddPkgAmenities = () => {
    return (
        <SideNav>
            <div className="mt-8 lg:mt-12">
                <div className="flex items-center space-x-2">
                    <h1 className="text-2xl font-semibold">Package Amenities</h1>
                </div>
                <p className='text-gray-500 mt-2'>Add/view/modify package amenities </p>
                <hr className="my-5" />
                <TabAddPkgAmenites />

            </div>
        </SideNav>
    )
}

export default AddPkgAmenities